// 收款方式icon
export const PAYMENT_TYPE_ICON_MAP = {
  1: 'icon-xianjin',
  2: 'icon-huiyuan',
  3: 'icon-saomafu',
  // XUANZHU: 'icon-huiyuan',
};

// 会员充值code
export const RECHARGE_CODE = 'MEMBER_STORED_VALUE';
